import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4ec3e5ba")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Farm ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`app-nav-toggle bg-gray-50 dark:bg-gray-${_ctx.darkModeBg}`)
  }, [
    _createVNode(_component_router_link, {
      to: { name: 'home' },
      class: _normalizeClass([
        'toggle-link px-6 rounded-l-md',
        { [_ctx.activeClasses]: !(_ctx.isTradePage || _ctx.isFarmPage) }
      ]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackGoal(_ctx.Goals.ClickNavInvest)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('invest')), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      to: { name: 'trade' },
      class: _normalizeClass([
        'toggle-link px-6 rounded-r-md',
        { [_ctx.activeClasses]: _ctx.isTradePage }
      ]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackGoal(_ctx.Goals.ClickNavTrade)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('trade')), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      to: { name: 'farm' },
      class: _normalizeClass([
        'toggle-link px-6 rounded-r-md',
        { [_ctx.activeClasses]: _ctx.isFarmPage }
      ]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackGoal(_ctx.Goals.ClickNavTrade)))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["class"])
  ], 2))
}